import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-bundle"
}
const _hoisted_2 = {
  key: 1,
  class: "overlay"
}
const _hoisted_3 = {
  class: "layer",
  "data-size": "small"
}
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "add form" }
const _hoisted_6 = { class: "assets" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "list-item" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  class: "label",
  for: "Email"
}
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "input" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "input" }
const _hoisted_16 = { for: "ExpirationDays" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "item"
}
const _hoisted_19 = {
  class: "checkbox",
  "data-info": ""
}
const _hoisted_20 = { class: "label" }
const _hoisted_21 = ["disabled", "placeholder"]
const _hoisted_22 = { for: "IsPrivate" }
const _hoisted_23 = { class: "info" }
const _hoisted_24 = { class: "tooltip" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "input" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 1,
  class: "item"
}
const _hoisted_29 = { class: "message" }
const _hoisted_30 = { class: "text" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = {
  key: 2,
  class: "validation-summary-errors"
}

import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetBundleEmail',
  props: {
    accentColor: {},
    headerColor: {},
    menuColor: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const userProfile = ref<any>({ expirationDay: [], shareModes: [], isBundleEmail: false });
const assets = ref<any[]>([]);
const isPrivateDisabled = ref(false);
const isShowDialog = ref(false);
const routes = (window as any).App.routes;

const emailBundleIds = computed(() => store.getters["privateAreaBundleEmailStore/emailBundleIds"]);

watch(emailBundleIds, (newValue) => {
	getBundleEmailData();
});

onMounted(() => {
	store.dispatch("privateAreaBundleEmailStore/getEmailBundleIds");

	getBundleEmailData();
});

async function getBundleEmailData() {
	try {
		const response = (await Axios.post(routes.PrivateArea_Asset_GetBundleEmailData, { assetIdMasters: emailBundleIds.value })).data;
		userProfile.value = response.userProfile;
		assets.value = response.assets;
		formData.value.expirationDays = userProfile.value.expirationDays[0].value;
	} catch (error) { }
}

async function setBundleEmail() {
	FormHelper.removeFocus();
	validationErrors.value = [];

	isLoading.value = true;

	formData.value.assetIdMasters = emailBundleIds.value;

	try {
		await Axios.post(routes.PrivateArea_Asset_SetBundleEmail, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

		let requestLogin = formData.value.isPrivate ? "login" : "public";

		GTagHelper.sendEvent("form_submit", "render_share", formData.value.expirationDays + "_" + requestLogin, assets.value.length);

		formData.value = {};

		isSuccess.value = true;

		store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Success"), type: "Success" });

		store.commit("privateAreaBundleEmailStore/setEmailBundleIds", []);
		store.dispatch("privateAreaBundleEmailStore/saveEmailBundleIds");

		setShowDialog();
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
	}

	isLoading.value = false;
}

function removeAsset(assetIdMaster: string) {
	store.commit("privateAreaBundleEmailStore/setEmailBundleIds", emailBundleIds.value.filter(x => x !== assetIdMaster));

	store.dispatch("privateAreaBundleEmailStore/saveEmailBundleIds");
}

function isValidationError(controlName: string): boolean {
	return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

function setShowDialog() {
	isShowDialog.value = !isShowDialog.value;
}

return (_ctx: any,_cache: any) => {
  return (userProfile.value.isBundleEmail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (assets.value.length !== 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setShowDialog())),
              style: _normalizeStyle([{'background-color': __props.headerColor}])
            }, [
              _createElementVNode("span", {
                class: "icon fastic-bundle",
                style: _normalizeStyle([{'color': __props.menuColor}])
              }, null, 4),
              _createElementVNode("div", {
                class: "count",
                style: _normalizeStyle([{'border-color': __props.headerColor}])
              }, _toDisplayString(assets.value.length), 5)
            ], 4))
          : _createCommentVNode("", true),
        (isShowDialog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "top",
                  style: _normalizeStyle([{'background-color': __props.headerColor}])
                }, [
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setShowDialog())),
                    class: "close icon fastic-close",
                    style: _normalizeStyle([{'color': __props.menuColor}])
                  }, null, 4),
                  _createElementVNode("div", {
                    class: "title",
                    style: _normalizeStyle([{'color': __props.menuColor}])
                  }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Bundle_Header_Title")), 5)
                ], 4),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(assets.value.length) + " " + _toDisplayString(_unref(localizer).get("PrivateArea.Common.RendersSelected")) + ":", 1),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assets.value, (asset, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "item"
                          }, [
                            _createTextVNode(_toDisplayString(asset.title) + " ", 1),
                            _createElementVNode("div", {
                              onClick: ($event: any) => (removeAsset(asset.idMaster)),
                              class: "remove"
                            }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Remove")), 9, _hoisted_9)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Bundle_RendersList_Title")), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "Email",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                          placeholder: _unref(localizer).get('PrivateArea.Common.Asset_ProfileRelationList_EmailPlaceholder'),
                          class: _normalizeClass([{'input-validation-error': isValidationError('Email')}, 'textbox'])
                        }, null, 10, _hoisted_13), [
                          [
                            _vModelText,
                            formData.value.email,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Expiration")), 1),
                        _withDirectives(_createElementVNode("select", {
                          id: "ExpirationDays",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.expirationDays) = $event)),
                          class: _normalizeClass([{'input-validation-error': isValidationError('ExpirationDays')}, 'dropdown'])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userProfile.value.expirationDays, (expirationDay, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: expirationDay.value
                            }, _toDisplayString(expirationDay.title), 9, _hoisted_17))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, formData.value.expirationDays]
                        ])
                      ])
                    ]),
                    (!isPrivateDisabled.value && formData.value.isDirectLink !== true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "IsPrivate",
                                disabled: isPrivateDisabled.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.isPrivate) = $event)),
                                placeholder: _unref(localizer).get('PrivateArea.Common.Asset_ProfileRelationList_EmailPlaceholder'),
                                class: _normalizeClass([{'input-validation-error': isValidationError('IsPrivate')}, 'checkbox'])
                              }, null, 10, _hoisted_21), [
                                [
                                  _vModelCheckbox,
                                  formData.value.isPrivate,
                                  void 0,
                                  { lazy: true }
                                ]
                              ]),
                              _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("PrivateArea.Common.RequestLogin")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(localizer).get("PrivateArea.Common.PrivateDescriptionTooltip")), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("textarea", {
                          id: "MessageNotes",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.messageNotes) = $event)),
                          placeholder: _unref(localizer).get('PrivateArea.Common.ProfileRelationList_Notes_Placeholder'),
                          class: _normalizeClass([{'input-validation-error': isValidationError('MessageNotes')}, 'textarea'])
                        }, null, 10, _hoisted_27), [
                          [
                            _vModelText,
                            formData.value.messageNotes,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    (formData.value.isPrivate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(localizer).get("PrivateArea.Common.PrivateDefault")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      (!isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (setBundleEmail())),
                            class: "button",
                            style: _normalizeStyle([{'background-color': __props.accentColor}])
                          }, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileRelationList_SetProfileRelation_Button")), 5))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "button load",
                            style: _normalizeStyle([{'background-color': __props.accentColor}])
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("div", { class: "loader" }, null, -1)
                          ]))], 4))
                    ]),
                    (validationErrors.value.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: validationError.name
                              }, _toDisplayString(validationError.message), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})